export default {"src":"/_next/static/media/eye-off.739b82fc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};